const veggies = [
    {
        name: "Spinach",
        calories: 7,
        protein: 0.86,
        carbs: 1
    },
    {
        name: "Broccoli",
        calories: 31,
        protein: 2.5,
        carbs: 6
    },
    {
        name: "Kale",
        calories: 33,
        protein: 3,
        carbs: 7
    },
    {
        name: "Artichoke hearts",
        calories: 89,
        protein: 4.9,
        carbs: 20
    },
    {
        name: "Asparagus",
        calories: 40,
        protein: 4.3,
        carbs: 7.4
    },
    {
        name: "Baby corn",
        calories: 51.3,
        protein: 1.8,
        carbs: 11.3
    },
    {
        name: "Bamboo shoots",
        calories: 25,
        protein: 2.3,
        carbs: 4.2
    },
    {
        name: "Green beans",
        calories: 33,
        protein: 3,
        carbs: 7
    },
    {
        name: "Bean sprouts",
        calories: 26,
        protein: 2.5,
        carbs: 5.2
    },
    {
        name: "Beets",
        calories: 33,
        protein: 3,
        carbs: 7
    },
    {
        name: "Brussels sprouts",
        calories: 7.6,
        protein: 1.3,
        carbs: 0.7
    },
    {
        name: "Cabbage",
        calories: 22,
        protein: 1.1,
        carbs: 5.2
    },
    {
        name: "Carrots",
        calories: 55,
        protein: 1.2,
        carbs: 13
    },
    {
        name: "Cauliflower",
        calories: 33,
        protein: 3,
        carbs: 7
    },
    {
        name: "Celery",
        calories: 27,
        protein: 1.2,
        carbs: 6
    },
    {
        name: "Chayote",
        calories: 38,
        protein: 1,
        carbs: 8.1
    },
    {
        name: "Cucumber",
        calories: 16,
        protein: 0.7,
        carbs: 3.8
    },
    {
        name: "Daikon",
        calories: 25,
        protein: 1,
        carbs: 5
    },
    {
        name: "Eggplant",
        calories: 35,
        protein: 0.8,
        carbs: 8.6
    },
    {
        name: "Turnips",
        calories: 42,
        protein: 1.4,
        carbs: 9.8
    },
    {
        name: "Hearts of palm",
        calories: 41,
        protein: 3.7,
        carbs: 6.7
    },
    {
        name: "Jicama",
        calories: 46,
        protein: 0.9,
        carbs: 11
    },
    {
        name: "Kohlrabi",
        calories: 36,
        protein: 2.3,
        carbs: 8.4
    },
    {
        name: "Leeks",
        calories: 76,
        protein: 2,
        carbs: 18.8
    },
    {
        name: "Mushrooms",
        calories: 44,
        protein: 3.4,
        carbs: 8.3
    },
    {
        name: "Okra",
        calories: 35,
        protein: 3,
        carbs: 7.2
    },
    {
        name: "Onions",
        calories: 99,
        protein: 3.1,
        carbs: 23
    },
    {
        name: "Pea pods",
        calories: 134,
        protein: 8.6,
        carbs: 25
    },
    {
        name: "Peppers",
        calories: 37,
        protein: 1.3,
        carbs: 8.9
    },
    {
        name: "Radishes",
        calories: 19,
        protein: 0.8,
        carbs: 3.9
    },
    {
        name: "Rutabaga",
        calories: 52,
        protein: 1.5,
        carbs: 12
    },
    {
        name: "Salad greens",
        calories: 9.1,
        protein: 0.7,
        carbs: 1.7
    },
    {
        name: "Sprouts",
        calories: 7.6,
        protein: 1.3,
        carbs: 0.7
    },
    {
        name: "Squash",
        calories: 41,
        protein: 1.9,
        carbs: 6.8
    },
    {
        name: "Zucchini",
        calories: 32,
        protein: 2.4,
        carbs: 5.6
    },
    {
        name: "Sugar snap peas",
        calories: 67,
        protein: 5.2,
        carbs: 11
    },
    {
        name: "Swiss chard",
        calories: 35,
        protein: 3.3,
        carbs: 7.2
    },
    {
        name: "Tomato",
        calories: 30,
        protein: 1.4,
        carbs: 6.4
    },
    {
        name: "Water chestnuts",
        calories: 75,
        protein: 2.3,
        carbs: 17
    },
]
// 1 serving carbs is 15 g
// 1 serving vegetables is 1 cup
// 1 serving of protein is 15 g
veggies.forEach(veg=>{
    veg.value = veg.name
    veg.label = veg.name
})
export default veggies